export default function StakeForVotingIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0729 28.3651L29.0179 16.0289C28.9445 15.588 28.563 15.2649 28.1161 15.2649H26.5166L29.5932 9.93612C29.7145 9.72612 29.7473 9.47658 29.6845 9.24235C29.6218 9.00812 29.4685 8.80841 29.2585 8.68721L18.3889 2.41156C18.1789 2.2903 17.9294 2.25745 17.6952 2.32025C17.4609 2.38299 17.2612 2.53625 17.14 2.74625L9.91242 15.2648H4.79734C4.35037 15.2648 3.96894 15.5879 3.89545 16.0289L1.84054 28.3651C1.79643 28.6302 1.87111 28.9012 2.04483 29.1063C2.21854 29.3113 2.47368 29.4296 2.74243 29.4296H30.171C30.4397 29.4296 30.6949 29.3114 30.8686 29.1063C31.0423 28.9012 31.117 28.6302 31.0729 28.3651ZM18.2664 4.4523L27.5525 9.81361L20.8441 21.4329H15.0299L10.1045 18.5892L18.2664 4.4523ZM3.82162 27.601L5.57191 17.0934H8.8567L8.06379 18.4667C7.81133 18.9041 7.96116 19.4632 8.39842 19.7157L11.3727 21.4329H7.85025C7.34533 21.4329 6.93596 21.8422 6.93596 22.3471C6.93596 22.8521 7.34533 23.2614 7.85025 23.2614H25.0631C25.5681 23.2614 25.9774 22.8521 25.9774 22.3471C25.9774 21.8422 25.5681 21.4329 25.0631 21.4329H22.9555L25.4609 17.0934H27.3415L29.0918 27.601H3.82162Z"
        fill="currentColor"
      />
    </svg>
  );
}
